import { LangHelper } from "@jnpmedi/helper-session";
import { MvnCodeBE } from "@maven-msg/code/const";
import { MvnCodeFE } from "@maven-msg/lang/const";
import { MvnMessageBinds } from "@maven-msg/lib/const";
import { MvnLanguage, MvnMessage as MvnMessageLib } from "@maven-msg/lib/Message"; // eslint-disable-line no-restricted-imports

const langHelper = new LangHelper({ stage: process.env.REACT_APP_STAGE! });

export function MvnMessage(
  mvn: MvnCodeFE | MvnCodeBE | string,
  binds?: MvnMessageBinds,
  naked?: Array<MvnCodeBE | MvnCodeFE | string>
): string {
  return MvnMessageLib(mvn, binds, naked, langHelper.getLang() as unknown as MvnLanguage);
}
